export const microphone_onboarding = {
    "seconds": 3,
    "title": {
        "en": "Recording starts in",
        "hi": "रिकॉर्डिंग शुरू होती है",
        "or": "ରେକର୍ଡିଂ ଆରମ୍ଭ ହେବ",
    }
}

export const microphone_screen = {
    3: {
        en: "Please ask in a quiet environment",
        hi: "शांत जगह में प्रश्न पूछे",
        or: "ଦୟାକରି ଏକ ଶାନ୍ତ ପରିବେଶରେ ଆପଣଙ୍କ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ",
    },
    2: {
        en: "Hold your phone like this",
        hi: "फोन को ऐसे मुंह के पास रखें",
        or: "ଆପଣଙ୍କ ଫୋନକୁ ଆପଣଙ୍କ ପାଟି ସାମ୍ନାରେ ଏହିପରି ଧରନ୍ତୁ",
    },
    1: {
        en: "Ask your complete question",
        hi: "अपना पूरा प्रश्न पूछें!",
        or: "ଆପଣଙ୍କର ସମ୍ପୂର୍ଣ୍ଣ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ",
    }
}